import {type TableColumn, useSortableTable} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import type {RefraCatalogData} from '../types'

import {useCanDeleteRefractory} from './useCanDeleteRefractory'

export const useRefraCatalogConfig = (): ReturnType<typeof useSortableTable<RefraCatalogData>> => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const canDeleteRefractory = useCanDeleteRefractory()
  const deleteColumn: TableColumn<RefraCatalogData> = {
    id: 'delete',
    label: t('refraCatalog.table.delete'),
    sortable: false
  }

  return useSortableTable<RefraCatalogData>(
    [
      {
        id: 'supplier',
        label: t('refraCatalog.table.supplier')
      },
      {
        id: 'brandName',
        label: t('refraCatalog.table.brandName')
      },
      {
        id: 'classificationGroup',
        label: t('refraCatalog.table.classificationGroup')
      },
      {
        id: 'subcategories',
        label: t('refraCatalog.table.subcategories')
      },
      {
        id: 'tds',
        label: t('refraCatalog.table.tds'),
        sortable: false
      },
      {
        id: 'bulkDensity',
        label: t('refraCatalog.table.bulkDensity')
      },
      {
        id: 'color',
        label: t('refraCatalog.table.globalColor')
      },
      {
        id: 'localColor',
        label: t('refraCatalog.table.localColor'),
        sortable: false
      },
      {
        id: 'actions',
        label: t('refraCatalog.table.reset'),
        sortable: false
      },
      ...(canDeleteRefractory ? [deleteColumn] : [])
    ],
    [canDeleteRefractory],
    {
      prefix: 'refra-catalog-table',
      postfixFieldName: 'cyPostfix'
    },
    {enableLocalSorting: true}
  )
}
